module.exports = __webpack_public_path__ + "static/img/cont64 (5).1f5b92c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (5).jpg
// module id = gjZy
// module chunks = 0